import { render, staticRenderFns } from "./suggestionsListEntries.vue.html?vue&type=template&id=5df4b7d6&"
import script from "./suggestionsListEntries.ts?vue&type=script&lang=ts&"
export * from "./suggestionsListEntries.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports